import T from 'prop-types'
/*
PW Filter Input

Basic text input with am "x" to clear the value

*/

import React from 'react'
import ReactDOM from 'react-dom'
import cx from 'classnames'

class FilterInput extends React.Component {
  static displayName = 'FilterInput'

  static propTypes = {
    className: T.string,
    onChange: T.func,
    onKeyPress: T.func,
    onKeyDown: T.func,
    focusOnMount: T.bool,
    placeholder: T.string,
    value: T.string
  }

  static defaultProps = {
    className: '',
    placeholder: ''
  }

  state = {
    value: ''
  }

  componentDidMount() {
    const { focusOnMount } = this.props
    if (focusOnMount) {
      this.focus()
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.props.value) {
      this.setState({ value: nextProps.value })
    }
  }

  _onChange = e => {
    this.setValue(e.target.value)
  }

  setValue = val => {
    this.setState({ value: val })
    const onChange = this.props.onChange
    if (onChange) {
      onChange(val)
    }
  }

  focus = () => {
    if (this.filterField) {
      ReactDOM.findDOMNode(this.filterField).focus()
    }
  }

  _btnToggle = () => {
    const val = this.state.value
    if (val) {
      this.setValue('') // clear
    } else {
      this.focus()
    }
  }

  _bindInputRef = el => {
    this.filterField = el
  }

  render() {
    const props = this.props
    const value = this.state.value
    const svgClasses = cx('search_to_clear_icon', value ? 'is_filtered' : null)
    return (
      <div className={cx(`filter_input`, props.className)}>
        <input
          className="form-control filter"
          onChange={this._onChange}
          onKeyDown={props.onKeyDown}
          onKeyPress={props.onKeyPress}
          placeholder={props.placeholder}
          ref={this._bindInputRef}
          type="text"
          value={this.state.value}
        />
        <svg className={svgClasses} onClick={this._btnToggle}>
          <g className="sc_group">
            <line className="sc_line" x1="9" x2="15" y1="21" y2="16" />
            <circle className="sc_circle" cx="19" cy="13" r="5" />
          </g>
        </svg>
      </div>
    )
  }
}

export default FilterInput
